import PropTypes from "prop-types";
import { ImgixNextImage as Image } from "@components/imgixNextImage";

import { keyify } from "@utils/keyify";
import { tagular } from "@cohesion/tagular";

export function Cards({ pois }) {
  const handleClick = (esid, title) => {
    const element = document.getElementById(esid);
    if (element) {
      window.scrollTo({
        top: element.getBoundingClientRect().top + window.scrollY - 20,
        behavior: "smooth",
      });
    }
    tagular("click", {
      actionOutcome: "INTERNALLINK",
      outboundUrl: "null",
      webElement: {
        elementType: "CARD",
        location: "ITINERARYDAY",
        name: "DAYOVERVIEW",
        position: "1",
        text: `${title}`,
      },
    });
  };

  return (
    <nav className="w-full h-full pb-4 overflow-scroll no-scrollbar">
      <ul className="flex h-full gap-3 pl-6 md:flex-col md:pl-0">
        {pois.map((poi, i) => (
          <li
            key={keyify(poi.title)}
            className="flex-none w-2/3 h-full shadow md:w-full md:h-2/5 md:shadow-none"
          >
            <button
              type="button"
              className="relative block w-full h-full overflow-hidden rounded bg-sand"
              onClick={() => handleClick(poi.esid, poi.title)}
            >
              <Image
                src={poi.image?.src}
                width={400}
                height={200}
                imgixParams={{ w: 400, h: 200, fit: "crop" }}
                className="object-cover w-full h-full"
                type={poi.meta.type.slug}
              />
              <div className="absolute bottom-0 left-0 z-10 w-full p-2 text-left bg-gradient-to-t from-black/65 via-black/45 to-transparent">
                <span className="text-sm font-semibold leading-tight text-white drop-shadow">
                  {i + 1}. {poi.title}
                </span>
              </div>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}

Cards.propTypes = {
  pois: PropTypes.arrayOf(
    PropTypes.shape({
      esid: PropTypes.string,
      title: PropTypes.string,
      slug: PropTypes.string,
      editorial: PropTypes.string,
      image: PropTypes.shape({
        src: PropTypes.string,
        credit: PropTypes.string,
        alt: PropTypes.string,
      }),
      meta: PropTypes.shape({
        address: PropTypes.string,
        coords: PropTypes.shape({
          lat: PropTypes.number,
          lon: PropTypes.number,
        }),
        tags: PropTypes.arrayOf(
          PropTypes.shape({ slug: PropTypes.string.isRequired })
        ),
        parent: PropTypes.shape({
          slug: PropTypes.string.isRequired,
        }),
      }),
    }).isRequired
  ).isRequired,
};
